import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["tabBtn", "panel", "actionsMenu"];

  connect() {
    document.addEventListener("click", this.closeMenu.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this.closeMenu.bind(this));
  }

  selectTab(event) {
    const tab = event.currentTarget.dataset.tab;

    this.tabBtnTargets.forEach((btn) => {
      const active = btn.dataset.tab === tab;
      btn.classList.toggle("bg-white",     active);
      btn.classList.toggle("shadow-sm",    active);
      btn.classList.toggle("text-gray-900", active);
      btn.classList.toggle("text-gray-500", !active);
    });

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.panel !== tab);
    });
  }

  toggleMenu(event) {
    event.stopPropagation();
    this.actionsMenuTarget.classList.toggle("hidden");
  }

  closeMenu() {
    this.actionsMenuTarget.classList.add("hidden");
  }
}
